export const MEDIA_PACK_MEDIA_CONTAINERS = {
  featuredContent: 'featuredContent',
  profileImage: 'profileImage',
};
